import React from 'react';
import { AppBar, Toolbar, Typography, Button } from '@mui/material';
import { StopCircle as StopCircleIcon } from '@mui/icons-material';

export const ImpersonationBar = ({ impersonatedUser, onStop }) => {
  return (
    <AppBar position="sticky" sx={{ top: 64, bgcolor: 'warning.main', zIndex: (theme) => theme.zIndex.appBar - 1 }}>
      <Toolbar sx={{ justifyContent: 'center' }}>
        <Typography variant="body1" sx={{ flexGrow: 1, textAlign: 'center' }}>
          You are currently viewing as <strong>{impersonatedUser}</strong>.
        </Typography>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<StopCircleIcon />}
          onClick={onStop}
        >
          Switch Back to Admin
        </Button>
      </Toolbar>
    </AppBar>
  );
};